import { Building, MapPinned } from "lucide-react";

import { Separator } from "components/ui/separator";
import { CoordinatesToGoogle } from "components/CoordinatesToGoogle";
import { DetailItem } from "components/DetailItem";
import { formatAddress } from "helpers/address";

export function AddressInfoCard({ address, caseName, position }) {
  return (
    <div className="tw:flex tw:max-h-80 tw:min-w-64 tw:flex-col tw:gap-2 tw:p-2">
      <div className="tw:flex tw:items-center tw:gap-2">
        <Building className="tw:size-4 tw:shrink-0 tw:text-(--color-text-muted)" />
        <span className="tw:font-semibold tw:text-sm tw:text-(--color-text-primary)">
          {caseName || "Case address"}
        </span>
      </div>

      <div className="tw:flex tw:min-h-0 tw:flex-1 tw:flex-col tw:gap-1.5 tw:overflow-y-auto">
        <DetailItem
          icon={MapPinned}
          label="Address"
          content={formatAddress(address)}
        />
      </div>

      <Separator />
      <CoordinatesToGoogle position={position} />
    </div>
  );
}
